import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Loginslider = () => {

    const sliderJsonData = [
        {
            image: "images/login-slider.jpg",
            category: "Living Room",
        },
        {
            image: "images/login-slider-1.png",
            category: "Bedrooms",
        },
        {
            image: "images/login-slider.jpg",
            category: "Office",
        },
        {
            image: "images/login-slider-1.png",
            category: "Dining Room",
        },
        {
            image: "images/venues.png",
            category: "Kitchen",
        },
    ];

    const [sliderData, setSliderData] = useState([]);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 768, 
                settings: {
                    slidesToShow: 3, 
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
           
            <div className="w-full">
                {sliderJsonData.length > 0 ? (
                    <Slider {...settings} className="login-slider">
                        {sliderJsonData.map((item, index) => (
                            <div key={index} className="h-screen">
                                <div className="text-center">
                                    <img src={item.image} alt={item.category} className="h-screen w-full" />
                                </div>
                            </div>
                        ))}
                    </Slider>
                ) : (
                    <p className="text-center">Loading...</p>
                )}
            </div>
        </>
    );
};

export default Loginslider;
